<template>
  <div class="loginBody">
    <div class="loginDiv">
      <div class="login-content">
        <el-row>
          <el-col style="text-align: center; padding: 25px 0 30px 0">
            <i class="iconfont icon-r-building" style="font-size: 36px;color: #ffffff"></i>
            <b style="font-size: 36px;color: #ffffff; margin-left: 8px"> 仓库管理系统</b>
          </el-col>
        </el-row>

        <!-- 关键：给 el-form 加个自定义类，重写布局 -->
        <el-form
            :model="loginForm"
            label-width="80px"
            :rules="rules"
            ref="loginForm"
            class="custom-form"
        >
          <!-- 账号 -->
          <el-form-item label="账号" prop="no">
            <el-input
                v-model="loginForm.no"
                autocomplete="off"
                class="fixed-input"
            ></el-input>
          </el-form-item>

          <!-- 密码 -->
          <el-form-item label="密码" prop="password">
            <el-input
                v-model="loginForm.password"
                show-password
                autocomplete="off"
                @keyup.enter.native="confirm"
                class="fixed-input"
            ></el-input>
          </el-form-item>

          <!-- 登录按钮：和输入框左对齐，宽度一致 -->
          <el-form-item>
            <div class="login-btn" @click="confirm" :class="{disabled: confirm_disabled}">
              登 录
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      confirm_disabled: false,
      loginForm: { no: "", password: "" },
      rules: {
        no: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  methods: {
    confirm() {
      if (this.confirm_disabled) return;
      this.confirm_disabled = true;
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.$axios
              .post(this.$httpUrl + "/user/login", this.loginForm)
              .then((res) => res.data)
              .then((res) => {
                if (res.code == 200) {
                  sessionStorage.setItem("CurUser", JSON.stringify(res.data.user));
                  this.$store.commit("setMenu", res.data.menu);
                  this.$router.replace("/Index");
                } else {
                  this.confirm_disabled = false;
                  alert("账号或密码错误！");
                }
              })
              .catch(() => {
                this.confirm_disabled = false;
                this.$message.error("网络异常");
              });
        } else {
          this.confirm_disabled = false;
        }
      });
    },
  },
};
</script>

<style scoped>
* { margin: 0; padding: 0; box-sizing: border-box; }

/* 背景高清不模糊 */
.loginBody {
  position: fixed;
  top: 0; left: 0;
  width: 100vw; height: 100vh;
  background: url("../assets/home.jpg") no-repeat center center;
  background-size: cover;
}

/* 登录卡片 */
.loginDiv {
  position: absolute;
  right: 80px; top: 50%;
  transform: translateY(-50%);
  width: 460px; height: 340px;
  background: rgba(20,20,20,0.7);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-content { width: 100%; padding: 0 30px; }

/* ========== 关键：重写表单布局，消除 Element 默认样式影响 ========== */
.custom-form >>> .el-form-item {
  margin-bottom: 18px !important;
}
/* 让 label 文字右对齐，和输入框整体对齐 */
.custom-form >>> .el-form-item__label {
  text-align: right !important;
  color: #fff !important;
}
/* 让表单内容区域左对齐 */
.custom-form >>> .el-form-item__content {
  margin-left: 80px !important;
}

/* 核心：输入框宽度锁定，不被任何样式挤压 */
.fixed-input {
  width: 240px !important;
  height: 40px !important;
}

/* 登录按钮：和输入框左对齐，宽度一致 */
.login-btn {
  width: 240px;
  height: 40px;
  line-height: 40px;
  background: #409eff;
  color: #fff;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
  font-size: 15px;
}
.login-btn.disabled {
  background: #9fc5e8;
  cursor: not-allowed;
}
</style>